module.exports = __webpack_public_path__ + "static/img/new-home-item5.f84b0e38.jpg";